import { lazyLoad } from "utils/loadable";

export const EmployerJobDetails = lazyLoad(
  () => import("./index"),
  (module) => module.EmployerJobDetails
);